import React, { FC, useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

interface TruncatedTextProps {
  text: string;
  className?: string;
  children?: React.ReactNode;
}

export const TruncatedText: FC<TruncatedTextProps> = ({
  text,
  className = "",
  children,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      const element = textRef.current;
      if (element) {
        setIsTruncated(element.scrollWidth > element.clientWidth);
      }
    };

    checkTruncation();

    const element = textRef.current;
    if (element) {
      const resizeObserver = new ResizeObserver(checkTruncation);
      resizeObserver.observe(element);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [text]);

  const content = children || text;

  if (!isTruncated) {
    return (
      <span ref={textRef} className={`truncate ${className}`}>
        {content}
      </span>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span ref={textRef} className={`truncate ${className}`}>
          {content}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-[600px] whitespace-nowrap">
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  );
};
